import { strIsNullOrEmpty, TextField } from '@fox/atoms';
import React, { useCallback, useState } from 'react';
import { useSwiftFoxTenantConfigContext } from '../../../swiftfox-tenant-config-context';
import { useActionCentreContext, useFilterClearListener } from '../action-centre-context';
import { ActionCentreColumn } from '../contracts';

// for the address filter we just add these 3 fields per address we want to filter on
// this one does not care that much about the dataIndex but more about the title to identify the address type in the backend
export function AddressFilter({ column, showAddressTypes }: { column: ActionCentreColumn; showAddressTypes: boolean }) {
	const { addressLocalisations } = useSwiftFoxTenantConfigContext();
	const { setFilter } = useActionCentreContext();
	const [localLocality, setLocalLocality] = useState<string>('');
	const [localPostcode, setLocalPostcode] = useState<string>('');
	const [localState, setLocalState] = useState<string>('');

	// Listen for filter clear events and reset local state
	useFilterClearListener(useCallback(() => {
		setLocalLocality('');
		setLocalPostcode('');
		setLocalState('');
	}, []));

	const updateFilter = useCallback((locality: string, postcode: string, state: string) => {
		let addressFilter: { locality?: string; postcode?: string; state?: string } | undefined = undefined;
		
		if (!strIsNullOrEmpty(locality) || !strIsNullOrEmpty(postcode) || !strIsNullOrEmpty(state)) {
			addressFilter = {};
			if (!strIsNullOrEmpty(locality)) addressFilter.locality = locality;
			if (!strIsNullOrEmpty(postcode)) addressFilter.postcode = postcode;
			if (!strIsNullOrEmpty(state)) addressFilter.state = state;
		}
		
		setFilter(addressFilter ? JSON.stringify(addressFilter) : undefined, column);
	}, [setFilter, column]);

	const handleLocalityChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		setLocalLocality(value);
		updateFilter(value, localPostcode, localState);
	}, [updateFilter, localPostcode, localState]);

	const handlePostcodeChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		setLocalPostcode(value);
		updateFilter(localLocality, value, localState);
	}, [updateFilter, localLocality, localState]);

	const handleStateChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		setLocalState(value);
		updateFilter(localLocality, localPostcode, value);
	}, [updateFilter, localLocality, localPostcode]);

	if (!addressLocalisations) return null;
	const suburbLabel = addressLocalisations.addressParts.suburb;
	const stateLabel = addressLocalisations.addressParts.state;

	return (
		<>
			<TextField
				value={localLocality}
				onChange={handleLocalityChange}
				size="small"
				placeholder={showAddressTypes ? `${column.title} ${suburbLabel.toLocaleLowerCase()}` : suburbLabel}
			/>
			<TextField
				value={localPostcode}
				type="number"
				onChange={handlePostcodeChange}
				size="small"
				placeholder={showAddressTypes ? `${column.title} postcode` : 'Postcode'}
			/>
			<TextField
				value={localState}
				onChange={handleStateChange}
				size="small"
				placeholder={showAddressTypes ? `${column.title} ${stateLabel.toLocaleLowerCase()}` : stateLabel}
			/>
		</>
	);
}
